import { Box, IconButton, Modal, Tooltip } from "@mui/material";
import { ThemeColor } from "../theme/color";
import moment from "moment";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import LeftSideArrow from "../../Icon/LeftSideArrow";
import { useEffect, useState } from "react";
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import { GetStudentReminderByIdAction } from "../../Redux/action/ApplicationAction";
import {
  DeleteStudentReminderService,
  getDefaultCommissionDetailsService,
} from "../../Redux/service/Application";
import ConfirmationModal from "../Modal/ConfirmationModal/ConfirmationModal";
import CustomDataTable from "../datatable/DataTable";
import { PayoutModalHeader, payoutModalStyle } from "./payoutModal";
import { CastSharp, Check, Circle, Edit, MilitaryTech, UpgradeOutlined } from "@mui/icons-material";
import { PaymentDetailModal } from "./PaymentDetailsModal.component";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { EditUniversityAmountModal } from "./EditUniversityAmount";
import { CallSharp } from "@material-ui/icons";

const style = { ...payoutModalStyle(), width: { xs: "95%", sm: "90%", md: "85%", lg: "80%" }, height: "85vh", maxHeight: "750px" };

export const PayoutAllReminderModal = ({
  HistoryModal,
  handleClose,
  AgentTransactionlist,
  debounce,
  handleInputChange,
  isAgent,
}) => {
  const dispatch = useDispatch();
  const isAgentUser =
    isAgent ?? (window?.sessionStorage?.getItem("user_role_type") === "agent");

  const [ReminderByIdlist, setReminderByIdlist] = useState([]);
  const [reminderId, setReminderId] = useState();
  const [confirmationopen, setConfirmationOpen] = useState(false);
  const [table_load, setTable_load] = useState(false);
  const [selectionModel, setSelectionModel] = useState([]);
  const [UserTransaction, setUserTransaction] = useState(false);

  const [edit, setEdit] = useState(false);

  const [stdId, setStdId] = useState("");

  const [transactionId, settransactionId] = useState({});

  const [DefaultCommission, setDefaultCommission] = useState();

  const [UniversityAmount, setUniversityAmount] = useState();

  const getDefaultCommission = async () => {
    console.log(DefaultCommission);
    await getDefaultCommissionDetailsService()
      .then((res) => {
        if (res.status === 200) {
          console.log("checking for calling", res);
          setDefaultCommission(res.data.commission);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getCommissionPercentage = (row) => {
    if (
      row?.organisationCommissionPercentage !== undefined &&
      row?.organisationCommissionPercentage !== null &&
      row?.organisationCommissionPercentage !== "" &&
      !isNaN(Number(row?.organisationCommissionPercentage)) &&
      Number(row?.organisationCommissionPercentage) > 0
    ) {
      return Number(row.organisationCommissionPercentage);
    }

    const isPriced =
      (Number(row?.grossCommission) > 0 ||
        Number(row?.chequePayable) > 0 ||
        Number(row?.invoiceTotalAmount) > 0) &&
      row?.isSettled;

    const rawComm = Number(row?.organisationCommission);
    if (
      !isPriced &&
      row?.organisationCommission !== undefined &&
      row?.organisationCommission !== null &&
      !isNaN(rawComm) &&
      rawComm > 0 &&
      rawComm <= 100
    ) {
      return rawComm;
    }

    const received = Number(row?.receivedFromUniversity) || 0;
    if (isPriced && received > 0 && rawComm > 0) {
      const calcRate = Math.round((rawComm / received) * 100);
      if (calcRate > 0 && calcRate <= 100) {
        return calcRate;
      }
    }

    return 80;
  };

  const getCommissionAmountUSD = (row) => {
    const rate = getCommissionPercentage(row);
    const isPriced =
      (Number(row?.grossCommission) > 0 ||
        Number(row?.chequePayable) > 0 ||
        Number(row?.invoiceTotalAmount) > 0) &&
      row?.isSettled;

    const rawComm = Number(row?.organisationCommission);
    const received = Number(row?.receivedFromUniversity) || 0;

    if (isPriced && !isNaN(rawComm) && rawComm > 0) {
      return rawComm;
    }

    if (received > 0) {
      return Math.round((received * rate) / 100);
    }

    if (!isPriced && rawComm === rate) {
      return 0;
    }

    if (!isNaN(rawComm) && rawComm > 0) {
      return rawComm;
    }

    return 0;
  };

  const historycolumns = [
    ...(!isAgentUser
      ? [
          {
            field: "action",
            headerName: "Update Transaction",
            width: 150,
            renderCell: (params) => {
              const handleUserTransactionActionClick = (e) => {
                e.stopPropagation();
                getDefaultCommission();
                setEdit(true);
                setStdId(params.row.studentId);
                setUserTransaction(true);
                console.log(params.row);
                settransactionId({
                  transactionId: params.row.id,
                  isCredited: params.row.isCredited,
                  isSettled: params.row.isSettled,
                  receivedFromUniversity: params.row.receivedFromUniversity,
                  amountPayableToAgent: params.row.amountPayableToAgent,
                  studentId: params.row?.studentId,
                  organisation: params.row?.organisation,
                  organisationCommissionPercentage: getCommissionPercentage(params.row),
                });
              };
              const handleUnivAmtActionClick = (e) => {
                e.stopPropagation();
                getDefaultCommission();
                setEdit(true);
                setStdId(params.row.studentId);
                handleCloseUniversityAmountModal();

                settransactionId({
                  transactionId: params.row.id,
                  // isCredited: params.row.isCredited,
                  receivedFromUniversity: params.row.receivedFromUniversity,
                  bonusFromUniversity: params.row.bonusFromUniversity,
                });
              };

              return (
                <Box className="d-flex align-items-center h-100">
                  <IconButton onClick={handleUserTransactionActionClick}>
                    <ModeEditIcon sx={{ fill: ThemeColor.LIGHTPURPLE }} />
                  </IconButton>
                  <Tooltip title="Amount & Bonus">
                    <IconButton onClick={handleUnivAmtActionClick}>
                      <MilitaryTech />
                    </IconButton>
                  </Tooltip>
                </Box>
              );
            },
          },
        ]
      : []),
    {
      field: "currentTransactionNumber",
      headerName: "Current Transaction Number",
      width: 150,
      renderCell: (params) => {
        return (
          <Box className="d-flex align-items-center h-100">
            {params.row?.currentTransactionNumber}
          </Box>
        );
      },
    },
    {
      field: "studentId.universityId",
      headerName: "Student Id",
      width: 150,
      renderCell: (params) => {
        return (
          <Box className="d-flex align-items-center h-100">
            {params.row?.studentId?.universityId}
          </Box>
        );
      },
    },
    {
      field: "receivedFromUniversity",
      headerName: "University Commission",
      width: 250,
      renderCell: (params) => {
        return (
          <div className="d-flex align-items-center h-100">
            $ {params.row.receivedFromUniversity}
          </div>
        );
      },
    },
    {
      field: "isSettled",
      headerName: "Settled",
      width: 150,
      renderCell: (params) => {
        return (
          <Box
            flexDirection={"row"}
            display={"flex"}
            className="d-flex align-items-center h-100"
          >
            {params.row.isSettled ? (
              <Check sx={{ fill: "green" }} />
            ) : (
              <Circle sx={{ fill: "grey" }} />
            )}
          </Box>
        );
      },
    },
    {
      field: "settledAt",
      headerName: "Settled At",
      width: 250,
      renderCell: (params) => {
        return (
          <div className="d-flex align-items-center h-100">
            {dayjs(params.row.settledAt).format("YYYY-MM-DD HH:MM")}
          </div>
        );
      },
    },
    {
      field: "isCredited",
      headerName: "Amount Received",
      width: 150,
      renderCell: (params) => {
        return (
          <Box
            flexDirection={"row"}
            display={"flex"}
            className="d-flex align-items-center h-100"
          >
            {params.row.isCredited ? (
              <Check sx={{ fill: "green" }} />
            ) : (
              <Circle sx={{ fill: "grey" }} />
            )}
          </Box>
        );
      },
    },
    {
      field: "creditedAt",
      headerName: "Amount Received At",
      width: 250,
      renderCell: (params) => {
        return (
          <div className="d-flex align-items-center h-100">
            {dayjs(params.row.creditedAt).format("YYYY-MM-DD HH:MM")}
          </div>
        );
      },
    },
    {
      // The rate that was agreed - 80% by default, or whatever it was set to (e.g. 84%, 87%).
      field: "organisationCommissionPercentage",
      headerName: "Organisation Commission Percentage",
      width: 280,
      renderCell: (params) => {
        const rate = getCommissionPercentage(params.row);
        return (
          <div className="d-flex align-items-center h-100">
            {rate} %
          </div>
        );
      },
    },
    {
      // What that rate works out to on this instalment in USD: e.g. $2,000 at 80% = $1,600.
      field: "organisationCommission",
      headerName: "Organisation Commission (In USD)",
      width: 280,
      renderCell: (params) => {
        const amount = getCommissionAmountUSD(params.row);
        return (
          <div className="d-flex align-items-center h-100">
            {amount > 0 ? `$ ${amount}` : "-"}
          </div>
        );
      },
    },

    {
      field: "exchangeRateUSDToINR",
      headerName: "Exchange Rate USD To INR",
      width: 250,
      renderCell: (params) => {
        const val = params.row.exchangeRateUSDToINR;
        return (
          <div className="d-flex align-items-center h-100">
            {val !== undefined && val !== null && val !== "" && Number(val) > 0 ? `₹ ${val}` : "-"}
          </div>
        );
      },
    },
    {
      field: "grossCommission",
      headerName: "Gross Commission",
      width: 250,
      renderCell: (params) => {
        const val = params.row.grossCommission;
        return (
          <div className="d-flex align-items-center h-100">
            {val !== undefined && val !== null && val !== "" && Number(val) > 0 ? `₹ ${val}` : "-"}
          </div>
        );
      },
    },
    {
      field: "gstPercentage",
      headerName: "Gst Percentage",
      width: 200,
      renderCell: (params) => {
        const val = params.row.gstPercentage;
        return (
          <div className="d-flex align-items-center h-100">
            {val !== undefined && val !== null && val !== "" ? `${val} %` : "-"}
          </div>
        );
      },
    },
    {
      field: "gstAmount",
      headerName: "Gst Amount (added)",
      width: 250,
      renderCell: (params) => {
        const val = params.row.gstAmount;
        return (
          <div className="d-flex align-items-center h-100">
            {val !== undefined && val !== null && val !== "" && Number(val) > 0 ? `₹ ${val}` : "-"}
          </div>
        );
      },
    },
    {
      field: "invoiceTotalAmount",
      headerName: "Invoice Total Amount",
      width: 250,
      renderCell: (params) => {
        const val = params.row.invoiceTotalAmount;
        return (
          <div className="d-flex align-items-center h-100">
            {val !== undefined && val !== null && val !== "" && Number(val) > 0 ? `₹ ${val}` : "-"}
          </div>
        );
      },
    },
    {
      field: "tdsPercentage",
      headerName: "Tds Percentage",
      width: 200,
      renderCell: (params) => {
        const val = params.row.tdsPercentage;
        return (
          <div className="d-flex align-items-center h-100">
            {val !== undefined && val !== null && val !== "" ? `${val} %` : "-"}
          </div>
        );
      },
    },
    {
      field: "tdsAmount",
      headerName: "Tds Amount (deducted)",
      width: 250,
      renderCell: (params) => {
        const val = params.row.tdsAmount;
        return (
          <div className="d-flex align-items-center h-100">
            {val !== undefined && val !== null && val !== "" && Number(val) > 0 ? `₹ ${val}` : "-"}
          </div>
        );
      },
    },
    {
      field: "chequePayable",
      headerName: "Cheque Payable (In ₹)",
      width: 250,
      renderCell: (params) => {
        const val = params.row.chequePayable;
        return (
          <div className="d-flex align-items-center h-100">
            {val !== undefined && val !== null && val !== "" ? `₹ ${val}` : "-"}
          </div>
        );
      },
    },
    {
      field: "notes",
      headerName: "Notes",
      width: 250,
    },
  ];

  const ReminderByIdlistState = useSelector(
    (state) => state.application?.studentreminder?.data?.reminders
  );
  //(ReminderByIdlistState);
  useEffect(() => {
    setReminderByIdlist(ReminderByIdlistState);
  }, [ReminderByIdlistState]);

  const handleClosePayementDetailModal = () => {
    setDefaultCommission();
    setUserTransaction(!UserTransaction);
  };

  const handleCloseUniversityAmountModal = () => {
    setDefaultCommission();
    setUniversityAmount(!UniversityAmount);
  };

  const rowColor = (params) => {
    if (params.row.isCredited && params.row.isSettled) return "row-green";
    if (params.row.isCredited) return "row-orange";
  };

  const processedRows = (AgentTransactionlist || []).map((row) => ({
    ...row,
    organisationCommissionPercentage: getCommissionPercentage(row),
    organisationCommissionUsd: getCommissionAmountUSD(row),
  }));

  return (
    <>
      {" "}
      <Modal
        open={HistoryModal}
        onClose={() => handleClose()}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PayoutModalHeader
            title="Transaction History"
            onClose={() => handleClose()}
          />

          {/* The grid scrolls itself; letting this wrapper scroll too put a
              second scrollbar next to the first one. */}
          <Box
            sx={{
              flex: 1,
              minHeight: 0,
              overflow: "hidden",
              p: { xs: 1.5, md: 2.5 },
              backgroundColor: "#F8FAFC",
            }}
          >
            <CustomDataTable
              row={processedRows}
              columns={historycolumns}
              loading={table_load}
              height={"100%"}
              tableHeight="100%"
              onSelectionChange={(newSelection) => {
                setSelectionModel(newSelection);
              }}
              getRowClassName={(params) => rowColor(params)}
            />
          </Box>
        </Box>
      </Modal>
      {DefaultCommission && (
        <PaymentDetailModal
          transactionId={transactionId}
          UserTransaction={UserTransaction}
          handleClose={handleClosePayementDetailModal}
          AgentTransactionlist={AgentTransactionlist}
          handleCloseReminder={handleClose}
          DefaultCommission={DefaultCommission}
        />
      )}
      <EditUniversityAmountModal
        transactionId={transactionId}
        UserTransaction={UniversityAmount}
        handleClose={handleCloseUniversityAmountModal}
        AgentTransactionlist={AgentTransactionlist}
        handleCloseReminder={handleClose}
        DefaultCommission={DefaultCommission}
      />
    </>
  );
};
